import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextValue from "./controls/TextValue";
import MeasureValue from "./controls/MeasureValue";
import LongTextValue from "./controls/LongTextValue";
import BooleanValue from "./controls/BooleanValue";
import ObjectValue from "./controls/ObjectValue";
import LabeledValue from "./controls/LabeledValue";

export function TratamientoExternoList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((tratamientoExterno, index) => (
        <ListGroupObjectItem
          key={tratamientoExterno.orden}
          index={index}
          value={tratamientoExterno}
          indexLabel={t("tratamientoExterno.orden")}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document
              .getElementById("tratamientosExternos")
              .scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <TextValue
                    label={t("tratamientoExterno.denominacion")}
                    value={value.denominacion}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tratamientoExterno.caudalAnual")}
                    value={value.caudalAnual}
                  />
                </Col>
                <Col lg={4}>
                  <BooleanValue
                    label={t("tratamientoExterno.conPeligrosidad")}
                    value={value.conPeligrosidad}
                  />
                </Col>
                <Col lg={4}>
                  {!value?.conPeligrosidad && (
                    <LabeledValue
                      label={t("tratamientoExterno.frecuenciaRetiros")}
                      value={value?.frecuenciaRetiros}
                      labelAttr="nombre"
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col>
                  <LongTextValue
                    label={t("tratamientoExterno.descripcion")}
                    value={value.descripcion}
                  />
                </Col>
              </Row>
              {!value?.conPeligrosidad && (
                <Row>
                  <Col lg={6}>
                    <ObjectValue
                      label={t("tratamientoExterno.transportista")}
                      value={value.transportista}
                    >
                      {({ value }) => (
                        <Grid>
                          <Row>
                            <Col>
                              <TextValue
                                label={t("personaJuridica.CUIT")}
                                value={value?.CUIT}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextValue
                                label={t("personaJuridica.razonSocial")}
                                value={value?.razonSocial}
                              />
                            </Col>
                          </Row>
                        </Grid>
                      )}
                    </ObjectValue>
                  </Col>
                  <Col lg={6}>
                    <ObjectValue
                      label={t("tratamientoExterno.tratador")}
                      value={value.tratador}
                    >
                      {({ value }) => (
                        <Grid>
                          <Row>
                            <Col>
                              <TextValue
                                label={t("personaJuridica.CUIT")}
                                value={value?.CUIT}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextValue
                                label={t("personaJuridica.razonSocial")}
                                value={value?.razonSocial}
                              />
                            </Col>
                          </Row>
                        </Grid>
                      )}
                    </ObjectValue>
                  </Col>
                </Row>
              )}
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
